import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import '../../Form.css';
import { getDefaultValues } from 'ra-core';
import {
  CALLCENTER_PLAN,
  CALLCENTER_STATUS_NEW,
  nameValidation2, nameValidation3,
  renderField,
  required,
  STATUSES_PAYMENT
} from '../../../common';

let Create = props => {
  const { handleSubmit, companies } = props;
  return (
    <form className="ScForm" onSubmit={handleSubmit}>
      <div>
        <h2>Добавить колцентр</h2>
        <div>
          <label>Название*</label>
          <Field
            name="name"
            data-lpignore
            autoComplete="off"
            component={renderField}
            validate={nameValidation2}
            type="text"
            placeholder=""
          />
        </div>
      </div>
      <div>
        <label>Кор. Название*</label>
        <Field
          name="shortName"
          data-lpignore
          autoComplete="off"
          component={renderField}
          validate={nameValidation3}
          type="text"
          placeholder="3 буквы"
        />
      </div>
      <div>
        <label>Статус</label>
        <Field name="statusnew" component="select">
          {CALLCENTER_STATUS_NEW.map(({ id, name, color }) => <option key={id} value={id} style={{ color: color }}>{name}</option>)}
        </Field>
      </div>
      <div>
        <label>Тип</label>
        <Field name="plan" component="select">
          {CALLCENTER_PLAN.map(({ id, name, color }) => <option key={id} value={id} style={{ color: color }}>{name}</option>)}
        </Field>
      </div>
      <div>
        <label>Доступные компании</label>
        <Field name="companies_list" component="select" style={{height: '200px'}} size="10" multiple>
          {companies.map(({ id, name }) => <option key={id} value={id} >{name}</option>)}
        </Field>
      </div>
      <div>
        <label>JuCRM ID*</label>
        <Field
          name="jucrmId"
          data-lpignore
          autoComplete="off"
          component={renderField}
          validate={required}
          type="text"
          placeholder=""
        />
      </div>

      <div>
        <button type="submit">
          Добавить колцентр
        </button>
      </div>
    </form>
  );
};

Create = reduxForm({
  form: 'createCallcenter'
})(Create);

Create = connect((state, props) => ({
  initialValues: getDefaultValues(state, props),
  saving: props.saving || state.admin.saving,
}))(Create);

export default Create;



// WEBPACK FOOTER //
// ./src/pages/admin/callcenter/Create.js